import { render, staticRenderFns } from "./myStudy.vue?vue&type=template&id=655d5988&scoped=true"
import script from "./myStudy.vue?vue&type=script&lang=js"
export * from "./myStudy.vue?vue&type=script&lang=js"
import style0 from "./myStudy.vue?vue&type=style&index=0&id=655d5988&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d5988",
  null
  
)

export default component.exports